import React, { useContext, useEffect } from 'react';
import { AppContextProvider } from '../AppLoader';
import { Box } from '@wix/design-system';
import { dataHooks } from '../../dataHooks';
import { DialogFormContainer } from '../DialogContainer';
import { keys } from '../../translationsKeys';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { ThemedHeading, ThemedText } from '../ThemedComponents';
import s from './Web5DeviceConnectionSuccessful.scss';

interface Web5ConnectionSuccessfulProps {}

export const Web5DeviceConnectionSuccessful: React.FC<Web5ConnectionSuccessfulProps> =
  observer(() => {
    const {
      rootStore: {
        web5DeviceLoginStore,
        displayStore: { isMobile },
      },
    } = useContext(AppContextProvider);
    const { t } = useTranslation();
    useEffect(() => {
      const timeout = setTimeout(() => {
        web5DeviceLoginStore.redirectToWix();
      }, 10000);

      return () => clearTimeout(timeout);
    }, []);
    return (
      <Box direction="vertical" align="center" width="100%">
        <DialogFormContainer
          dataHook={dataHooks.web5DeviceConnectionSuccessful.container}
          formClasses={[s.web5DeviceConnectionSuccessfulForm]}
          mainHeaderProps={{ showBackButton: false }}
        >
          <Box marginBottom={3} verticalAlign="middle">
            <ThemedHeading
              appearance={isMobile ? 'H2' : 'H1'}
              dataHook={dataHooks.web5DeviceConnectionSuccessful.title}
            >
              {t(keys['web5Device.connection.successful.title'])}
            </ThemedHeading>
          </Box>
          <Box marginBottom={3} verticalAlign="middle">
            <ThemedText weight="bold" size="small">
              {t(keys['web5Device.connection.successful.content.first'])}
            </ThemedText>
          </Box>
          <Box marginBottom={3} verticalAlign="middle">
            <ThemedText size="small">
              {t(
                keys[
                  'web5Device.connection.successful.content.second.text.third'
                ],
              )}
            </ThemedText>
          </Box>
        </DialogFormContainer>
      </Box>
    );
  });
